 import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { /*Badge,*/ Row, Col, Button, DropdownButton, Dropdown, ButtonGroup} from 'react-bootstrap';
import { VendorAddressPopUp } from '../components/VendorAddressPopUp';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as XLSX from "@e965/xlsx/xlsx.mjs";
import { Loading } from '../components/Loading';
import { TableFilter } from '../components/TableFilter';
import CommonUtils from '../utils/siteUtils.js';

import '../styles/Vendor.css';

const RemitAddressesTable = (props) => {   
    const [vendorAddresses, setVendorAddresses] = useState([]);   
    //DE990037 - Fixed Inactive address helper text.
    const inactivateBtnText = "This is a system default address, please reach out via the Contact Us page for assistance.";                              
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [filterText, setFilterText] = React.useState('');
    const filteredItems = vendorAddresses.filter(
        item => (item.address1 && item.address1.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.address2 && item.address2.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.address3 && item.address3.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.city && item.city.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.stateProvince && item.stateProvince.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.country && item.country.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.postalCode && item.postalCode.toLowerCase().includes(filterText.toLowerCase()))
    );
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (JSON.stringify(props.vendorData.vendorAddresses) !== JSON.stringify(vendorAddresses)) {
            var addresses = props.vendorData.vendorAddresses;
            addresses = CommonUtils.sortRemitAddresses(addresses);
           
            setVendorAddresses(addresses);
            
            buildTable();
        }
    },[props.vendorData.vendorAddresses, vendorAddresses]);
    //Main Search function
    const buildTable=() => {
        setLoading(false);
    }
    const prepForExport = () => {
        //Remove fields
        var exportAddr = [];
        for (var i = 0; i < vendorAddresses.length; i++) {
            var address = vendorAddresses[i];
            var trimAddress = {};
            for (var x = 0; x < columns.length; x++) {
                var col = columns[x];
                if (col.name) {
                    var colName = col.name.props.children;
                    var colId = col["id"];
                    var adVal = address[colId];
                    trimAddress[colName] = adVal;
                }
            }
            exportAddr.push(trimAddress);            
        }
        return exportAddr;
    }
    const exportExcelResults = () => {
        //Export to XLSX
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        var fileTitle = `UHG_PSSP_Remit_Export`;
        var fileName = `${dateStr}_UHG_PSSP_${curSupp}_Remit.xlsx`;
        var exportAddresses = prepForExport();
        const ws = XLSX.utils.json_to_sheet(exportAddresses);
        var colArr = getExportColumns();
        //Export
        XLSX.utils.sheet_add_aoa(ws, colArr, { origin: "A1" });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileTitle);
        XLSX.writeFile(wb, fileName);
    }
        const getExportColumns = () => {
            //update column names
            var colArr = [];
            var result = columns
                // eslint-disable-next-line array-callback-return
                .map(item => {
                const obj = {};
                if (item.name) {
                    obj["name"] = item.name.props.children;
                    return obj["name"];
                }
            })

            colArr.push(result);
            return colArr;
        }
    const exportCSVResults = () => {
        //Export to CSV
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        var fileTitle = `UHG_PSSP_Remit_Export`;
        var fileName = `${dateStr}_UHG_PSSP_${curSupp}_Remit.csv`;     
        
        //create sheet
        var exportAddresses = prepForExport();
        const ws = XLSX.utils.json_to_sheet(exportAddresses);
        var colArr = getExportColumns();
        //Export
        XLSX.utils.sheet_add_aoa(ws, colArr, { origin: "A1" });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileTitle);
        XLSX.writeFile(wb, fileName, { outputType: "string", bookType: "csv" });
    }   
    const columns = [
        {
            id: 'addressSequenceNumber',
            name: <span className='dtHeaderCell' title=''>Remit Number</span>,
            selector: row => row.addressSequenceNumber,
            sortable: false,
            wrap: false,      
            cell: row => <>{(row.addressSequenceNumber) ? row.addressSequenceNumber : ' '}</>,
            maxWidth: "110px"
        },
        {
            id: 'country',
            name: <span className='dtHeaderCell' title='Country'>Country</span>,
            selector: row => row.country, 
            wrap: false,
            cell: row => <>{(row.country) ? row.country : ' '}</>,
            maxWidth: "75px"
        },
        {
            id: 'address1',
            name: <span className='dtHeaderCell' title='Address 1'>Address Line 1 (or DBA)</span>,
            selector: row => row.address1,
            wrap: false,
            cell: row => <>{(row.address1) ? row.address1 : ' '}</>,
           
        },
        {
            id: 'address2',
            name: <span className='dtHeaderCell' title='Address 2'>Address Line 2</span>,
            selector: row => row.address2,
            wrap: false,
            cell: row => <>{(row.address2) ? row.address2 : ' '}</>,
            minwidth: "175px",
            maxwidth: "250px"
        },       
        {
            id: 'address3',
            name: <span className='dtHeaderCell' title='Address 3'>Address Line 3</span>,
            selector: row => row.address3,
            wrap: false,
            cell: row => <>{(row.address3) ? row.address3 : ' '}</>,
            maxwidth: "150px"
        },  
        {
            id: 'city',
            name: <span className='dtHeaderCell' title='City'>City</span>,
            selector: row => row.city,
            cell: row => <>{(row.city) ? row.city : ' '}</>,
            minwidth: "200px",
            maxwidth: "250px"
        },  
        {
            id: 'stateProvince',
            name: <span className='dtHeaderCell' title='State/Province'>State/Province</span>,
            selector: row => row.stateProvince,
            wrap: false,
            cell: row => <>{(row.stateProvince) ? row.stateProvince : ' '}</>,
            maxWidth: "150px",
        },  
        {
            id: 'postalCode',
            name: <span className='dtHeaderCell' title='State'>Postal</span>,
            selector: row => row.postalCode,
            wrap: false,
            cell: row => <>{(row.postalCode) ? row.postalCode : ' '}</>,
            maxWidth: "150px"
        }, 
        {
            id: 'effStatus',
            name: <span className='dtHeaderCell' title='effStatus'>Status</span>,
            selector: row => row.effStatus,
            omit:true,
            cell: row => <>{(row.effStatus) ? row.effStatus : ' '}</>,
        }, 
        {
            id: 'defaultAddress',
            name: <span className='dtHeaderCell' title='defAddress'>Default Address</span>,
            selector: row => row.defaultAddress,
            omit: true,
            cell: row => <>{(row.defaultAddress) ? row.defaultAddress : ' '}</>,
        }, 
        {
            cell: row => {
                return (
                        (row.effStatus === 'A')
                        ? (props.isReadOnly)
                            ? (row.defaultAddress === 'Y')
                                ? <></> //<Button className="vContactBtn" disabled={true} title={inactivateBtnText} >Inactivate</Button>                                
                            : <></>
                            : (row.defaultAddress === 'N')
                            ? <>
                                    <VendorAddressPopUp currentAddress={row} vendorData={props.vendorData} allAddresses={vendorAddresses} editMode="Edit" onAddressChange={props.onAddressChange} />
                                    <VendorAddressPopUp currentAddress={row} vendorData={props.vendorData} allAddresses={vendorAddresses} editMode="Inactivate" onAddressChange={props.onAddressChange} />
           
                                </>
                                : <>
                                    <VendorAddressPopUp currentAddress={row} vendorData={props.vendorData} allAddresses={vendorAddresses} editMode="Edit" onAddressChange={props.onAddressChange} />
                                   
                                    <OverlayTrigger
                                        overlay={<Tooltip>{inactivateBtnText}</Tooltip>}>
                                        <span>
                                            <Button className="vActionBtn right" disabled={true}>Inactivate</Button>
                                        </span>
                                    </OverlayTrigger>

                                </>
                        :<div className="inactivateAddTblRow">
                            <div className="inactivateAddTbl">Inactive</div>
                            </div>

                    )
            },
            wrap: false,
            right: "true",
            maxWidth: "300px",
        }
              
    ];
    const customStyles = {
        // search results DataTable custom styles
        table: {
            style: {
                // table styles
                padding: '0',
                margin: '0'
            },
        },
        headCells: {
            style: {
                // header styles
                fontSize: '14px',
                justifyContent: 'left !important',
                color: 'white',
                paddingLeft: '1%',
                borderRight: '1px solid white',
                fontWeight: '400',
                
            },
        },
        head: {
            style: {
                // head styles - so calendars go over
                zIndex: '99'
            },
        },
        headRow: {
            style: {
                // header styles
                backgroundColor: '#003C71',
            },
        },
    };

    const onFilter = (searchText) => {
        //if (searchText) {
            setFilterText(searchText);
            setResetPaginationToggle(!resetPaginationToggle);
       // }
    }
    const onFilterClear = () => { setFilterText(''); }
    //US7579449 - EMEA+ View - Address
    var isEMEASupplier = (props.vendorData) ? CommonUtils.determineIfVendorIsEMEAPlus(props.vendorData) : false;
    var actionBtn = (props.isReadOnly || isEMEASupplier)
        ? <></>
        : <VendorAddressPopUp currentAddress={null} vendorData={props.vendorData} allAddresses={vendorAddresses} editMode="Add" btnClassName="remitTblAdd" onAddressChange={props.onAddressChange} />;
    return (
        (loading)
            ? <div><Loading /></div>
                : <>       
                  <Row id="resultsRow">
                    <Col xs={2}>
                        <TableFilter onFilter={onFilter} onFilterClear={onFilterClear } />
                    </Col>
                    <Col xs={{ span: 1, offset: 7 }}>
                        <div className="searchResultsCountPill"><span className="searchResultsPill"> {filteredItems.length}</span> Results</div>
                    </Col>         
                     <Col xs={2}>
                        {actionBtn}
                            <ButtonGroup className="exportButtonGrp" style={{padding:0, float:"right"}}>
                            <DropdownButton
                                title="Export Results"
                                id="bg-nested-dropdown">
                                <Dropdown.Item eventKey="1" onClick={() => exportCSVResults()}>CSV</Dropdown.Item>
                                <Dropdown.Item eventKey="2" onClick={() => exportExcelResults()}>Excel</Dropdown.Item>
                            </DropdownButton>
                        </ButtonGroup>
                    </Col> 
            </Row>
            <Row>
                <Col sm={12} id="searchResults">
                        <DataTable
                            keyField="vendorAddressId"
                            columns={columns}
                            data={filteredItems}
                            defaultSortFieldId="addressSequenceNumber"
                            fixedHeader
                            striped
                            responsive     
                            pagination
                            paginationPerPage={25}
                            paginationRowsPerPageOptions={[25, 50, 100]} 
                            customStyles={customStyles}                                             
                    />
                </Col>
            </Row>
          </>
        )
}
export default RemitAddressesTable



